import * as api from '@/axios/api'
import { loc } from '@/axios/storage'
const state = {
    isLogin: null,
    token: '',
    userInfo: {},
    otherData: {},
    publicMenu: {
        bottom_menu: [],
        top_menu: []
    },
}
const getters = {
    userGetMessageClearGe(state) { //用户确认发货
        return state.userGetMessageClearSt
    },
}
const mutations = {
    userGetSignMu(state, res) {  //签到 
        state.userGetSignSt = res
    },
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_USERINFO: (state, userInfo) => {
        state.userInfo = userInfo
    },
    SavePlubicMenu: (state, publicMenu) => {
        state.publicMenu = publicMenu
    },
    SaveOtherData: (state, otherData) => {
        state.otherData = otherData
    },
}
const actions = {
    // 登录
    login({ commit }, userInfo) {
        const { username, password, captcha, key } = userInfo
        return new Promise((resolve, reject) => {
            api.user_login({ username: username.trim(), password, captcha, key }).then(response => {
                if (response.status == 3 || response.status == 4) {
                    resolve(response);
                }
                const { data } = response
                commit('SET_TOKEN', data.access_token)
                loc.set('client_token', data.access_token)
                resolve(response)
            }).catch(error => {
                console.log(error)
                reject(error)
            })
        })
    },
    // 注册
    register({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            api.user_register(userInfo).then(response => {
                if (response.status == 3 || response.status == 4) {
                    resolve(response);
                }
                resolve(response)
            }).catch(error => {
                console.log(error)
                reject(error)
            })
        })
    },
    // 退出登录
    logout({ commit }) {
        return new Promise((resolve, reject) => {
            api.user_logout().then(response => {
                commit('SET_TOKEN', null)
                loc.remove('client_token')
                resolve(response)
            }).catch(error => {
                console.log(error)
                reject(error)
            })
        })
    },
    // 用户信息
    getUserInfo({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            api.getUserInfo().then(response => {
                commit('SET_USERINFO', response.data)
                resolve(response)
            }).catch(error => {
                console.log(error)
                reject(error)
            })
        })
    },
    resetToken({ commit, dispatch }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            loc.remove('client_token')
            resolve()
        })
    },
    
}


export default {
    namespaced: true,
    state, getters, mutations, actions
}


// WEBPACK FOOTER //
// ./src/store/usersStore.js